import { MapPin } from "lucide-react";

// Coordinates are geocoded server-side when the organizer saves the location
// (see worker/src/lib/geocode.ts) and come down already attached to the
// wedding object -- geocoding from here, in the visitor's browser, doesn't
// work at all: Nominatim's search endpoint sends no CORS header, so every
// browser silently blocks the request and this always fell back to the
// "couldn't find it" state. Embedded as a real OSM map centered on those
// coordinates; Google's keyless "output=embed" trick was dropped for the same
// reason it was dropped before -- it depends on third-party storage in the
// iframe, which browsers increasingly block.
export default function LocationMap({ wedding }) {
  if (!wedding.location) return null;
  const openUrl = wedding.location_map_url || `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(wedding.location)}`;

  let embedSrc = null;
  if (wedding.location_lat != null && wedding.location_lon != null) {
    const { location_lat: lat, location_lon: lon } = wedding;
    const d = 0.006; // ~650m half-span: a tight, venue-level zoom
    const bbox = [lon - d, lat - d, lon + d, lat + d].join(",");
    embedSrc = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${lon}`;
  }

  return (
    <section className="py-20 sm:py-28 px-6 sm:px-12 max-w-5xl mx-auto" data-testid="location-section">
      <div className="text-center mb-8">
        <p className="eyebrow mb-4">Dove</p>
        <h2 className="font-wed text-3xl sm:text-4xl mb-5">{wedding.location}</h2>
        <a
          href={openUrl}
          target="_blank"
          rel="noreferrer"
          className="btn-outline-wed inline-flex items-center gap-2 w-fit"
          data-testid="location-open-maps-link"
        >
          <MapPin size={16} /> Apri in Google Maps
        </a>
      </div>
      <div className="rounded-3xl overflow-hidden border shadow-sm bg-[#f5f3ec]" style={{ borderColor: "#e3ddd2", minHeight: 380 }}>
        {embedSrc ? (
          <iframe
            title="Mappa location"
            src={embedSrc}
            width="100%"
            height="380"
            style={{ border: 0, display: "block" }}
            loading="lazy"
            data-testid="location-map-iframe"
          />
        ) : (
          <div className="h-[380px] flex items-center justify-center text-sm text-neutral-400 text-center px-6">
            Non siamo riusciti a geolocalizzare "{wedding.location}" — usa il bottone qui sopra per aprire la mappa.
          </div>
        )}
      </div>
    </section>
  );
}
